import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { accountUser, accountUserSaga } from './account/user';
import { app, appSaga } from './app';
import { widget, widgetSaga } from './widget';
import { noticeProduct, noticeProductSaga } from './notice/product';
import { noticeStore, noticeStoreSaga } from './notice/store';
import { csReviewSaga } from './cs/review';
import { csQna, csQnaSaga } from './cs/qna';
import { csInquiry, csInquirySaga } from './cs/inquiry';
import { version, versionSaga } from './version';
import { event, eventSaga } from './event';
import { product, productSaga } from './product';
import { brand, brandSaga } from './brand';
import { order, orderSaga } from './order';
import { balance, balanceSaga } from './balance';
import { coupon, couponSaga } from './coupon';
import { point, pointSaga } from './point';
import { recommendProduct, recommendProductSaga } from './recommend/product';
import { recommendReview, recommendReviewSaga } from './recommend/review';
import { recommendTag, recommendTagSaga } from './recommend/tag';
import { recommendSearchWord, recommendSearchWordSaga } from './recommend/searchWord';
import { recommendEvent, recommendEventSaga } from './recommend/event';
import { recommendStore, recommendStoreSaga } from './recommend/store';
import { tag, tagSaga } from './tag';
import { searchWord, searchWordSaga } from './searchWord';
import { remoteImage, remoteImageSaga } from './remoteImage';

export function* rootSaga() {
  yield all([
    appSaga(),
    accountUserSaga(),
    brandSaga(),
    widgetSaga(),
    noticeProductSaga(),
    noticeStoreSaga(),
    csReviewSaga(),
    csQnaSaga(),
    csInquirySaga(),
    versionSaga(),
    eventSaga(),
    productSaga(),
    orderSaga(),
    balanceSaga(),
    couponSaga(),
    pointSaga(),
    recommendProductSaga(),
    recommendReviewSaga(),
    recommendTagSaga(),
    recommendSearchWordSaga(),
    recommendEventSaga(),
    recommendStoreSaga(),
    tagSaga(),
    searchWordSaga(),
    remoteImageSaga(),
  ]);
}

const rootReducer = combineReducers({
  app,
  accountUser,
  brand,
  widget,
  noticeProduct,
  noticeStore,
  csQna,
  csInquiry,
  version,
  event,
  product,
  order,
  balance,
  coupon,
  point,
  recommendProduct,
  recommendReview,
  recommendTag,
  recommendSearchWord,
  recommendEvent,
  recommendStore,
  tag,
  searchWord,
  remoteImage,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
